import * as React from "react";
import * as ReactDOM from "react-dom";
import { kResume } from "./data";
import { Resume } from "./resume";

screen.orientation.addEventListener("change", () => {
  location.reload();
});

ReactDOM.render(<Resume {...kResume} />, document.getElementById("app"));
